const styles = `:host([compact]) .popover {
  font: var(--goto-tooltip-font);
  padding: var(--goto-spacing-01) var(--goto-spacing-02);
  text-align: initial;
}`; export default styles;